<template>
  <section id="icon__section">
    <svg class="icon" :class="iconName">
      <use :xlink:href="'#' + iconName"></use>
    </svg>

    <!-- Audio -->
    <symbol id="icon-uniE948" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-audio'">
      <title>{{ $t('appUser.resourcesIcons.audio.name') }}</title>
      <path
        d="M9 18h-2v14h2q0.406 0 0.703-0.297t0.297-0.703v-12q0-0.406-0.297-0.703t-0.703-0.297v0zM23 18q-0.406 0-0.703 0.297t-0.297 0.703v12q0 0.406 0.297 0.703t0.703 0.297h2v-14h-2zM32 16q0-3.313-1.25-6.234t-3.422-5.094-5.094-3.422-6.234-1.25-6.234 1.25-5.094 3.422-3.422 5.094-1.25 6.234q0 1.438 0.25 2.813t0.719 2.656q-0.469 0.781-0.719 1.672t-0.25 1.859q0 1.313 0.453 2.5t1.266 2.109 1.906 1.531 2.375 0.797v-13.875q-0.75 0.125-1.438 0.375t-1.313 0.656q-0.125-0.625-0.188-1.281t-0.063-1.313q0-2.688 1.016-5.063t2.781-4.141 4.141-2.781 5.063-1.016 5.063 1.016 4.141 2.781 2.781 4.141 1.016 5.063q0 0.656-0.063 1.313t-0.188 1.281q-0.625-0.406-1.313-0.656t-1.438-0.375v13.875q1.281-0.188 2.375-0.797t1.906-1.531 1.266-2.109 0.453-2.5q0-0.969-0.25-1.859t-0.719-1.672q0.469-1.281 0.719-2.656t0.25-2.813v0z"></path>
    </symbol>

    <!-- Course -->
    <symbol id="icon-uniE95C1" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-course'">
      <title>{{ $t('appUser.resourcesIcons.course.name') }}</title>
      <path
        d="M28.5 0h-27q-0.625 0-1.063 0.438t-0.438 1.063v23q0 0.625 0.438 1.063t1.063 0.438h8.906l-4.063 4.094q-0.344 0.313-0.344 0.781t0.344 0.781q0.156 0.188 0.359 0.266t0.422 0.078 0.422-0.078 0.359-0.266l5.688-5.656h0.406v5q0 0.406 0.297 0.703t0.703 0.297 0.703-0.297 0.297-0.703v-5h0.406l5.688 5.656q0.156 0.188 0.359 0.266t0.422 0.078 0.422-0.078 0.359-0.266q0.344-0.313 0.344-0.781t-0.344-0.781l-4.063-4.094h8.906q0.625 0 1.063-0.438t0.438-1.063v-23q0-0.625-0.438-1.063t-1.063-0.438v0zM12 6l8 5-8 5v-10zM25 22h-20q-0.406 0-0.703-0.297t-0.297-0.703 0.297-0.703 0.703-0.297h20q0.406 0 0.703 0.297t0.297 0.703-0.297 0.703-0.703 0.297v0z"></path>
    </symbol>

    <!-- Document -->
    <symbol id="icon-uniE9AD" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-document'">
      <title>{{ $t('appUser.resourcesIcons.document.name') }}</title>
      <path
        d="M28.688 7.156q-0.531-0.719-1.234-1.516t-1.484-1.609q-0.813-0.781-1.609-1.484t-1.516-1.234q-1.219-0.875-1.859-1.094t-0.984-0.219h-15.5q-1.031 0-1.766 0.734t-0.734 1.766v27q0 1.031 0.734 1.766t1.766 0.734h23q1.031 0 1.766-0.734t0.734-1.766v-19.5q0-0.344-0.219-0.984t-1.094-1.859v0zM24.531 5.469q0.719 0.719 1.297 1.359t0.984 1.172h-4.813v-4.813q0.531 0.406 1.172 0.984t1.359 1.297v0zM28 29.5q0 0.219-0.141 0.359t-0.359 0.141h-23q-0.219 0-0.359-0.141t-0.141-0.359v-27q0-0.219 0.141-0.359t0.359-0.141h15.5v7q0 0.406 0.297 0.703t0.703 0.297h7v19.5zM23 26h-14q-0.406 0-0.703-0.297t-0.297-0.703 0.297-0.703 0.703-0.297h14q0.406 0 0.703 0.297t0.297 0.703-0.297 0.703-0.703 0.297v0zM23 22h-14q-0.406 0-0.703-0.297t-0.297-0.703 0.297-0.703 0.703-0.297h14q0.406 0 0.703 0.297t0.297 0.703-0.297 0.703-0.703 0.297v0zM23 18h-14q-0.406 0-0.703-0.297t-0.297-0.703 0.297-0.703 0.703-0.297h14q0.406 0 0.703 0.297t0.297 0.703-0.297 0.703-0.703 0.297v0z"></path>
    </symbol>

    <!-- Guide -->
    <symbol id="icon-uniEC58" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-jguide'">
      <title>{{ $t('appUser.resourcesIcons.guide.name') }}</title>
      <path d="M12 26h20v4h-20v-4zM12 14h20v4h-20v-4zM12 2h20v4h-20v-4zM6 0v8h-2v-6h-2v-2h4zM4 16.438v1.563h4v2h-6v-4.563l4-1.875v-1.563h-4v-2h6v4.563zM8 22v10h-6v-2h4v-2h-4v-2h4v-2h-4v-2h6z"></path>
    </symbol>

    <!-- Interactive -->
    <symbol id="icon-uniE99A" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-interactive'">
      <title>{{ $t('appUser.resourcesIcons.interactive.name') }}</title>
      <path
        d="M6 18.344v4.656q0 0.75 0.781 1.625t2.141 1.625 3.188 1.25 3.891 0.5 3.891-0.5 3.188-1.25 2.141-1.625 0.781-1.625v-4.656l-10 5-10-5zM16 4l-16 8 16 8 12.969-6.5-0.969 8.5h2v-9l2-1-16-8zM17 12.438q-0.594 0-1.016-0.422t-0.422-1.016 0.422-1.016 1.016-0.422 1.016 0.422 0.422 1.016-0.422 1.016-1.016 0.422v0z"></path>
    </symbol>

    <!-- Online course -->
    <symbol id="icon-uniE95C2" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-online-course'">
      <title>{{ $t('appUser.resourcesIcons.onlineCourse.name') }}</title>
      <path
        d="M28.5 0h-27q-0.625 0-1.063 0.438t-0.438 1.063v23q0 0.625 0.438 1.063t1.063 0.438h8.906l-4.063 4.094q-0.344 0.313-0.344 0.781t0.344 0.781q0.156 0.188 0.359 0.266t0.422 0.078 0.422-0.078 0.359-0.266l5.688-5.656h0.406v5q0 0.406 0.297 0.703t0.703 0.297 0.703-0.297 0.297-0.703v-5h0.406l5.688 5.656q0.156 0.188 0.359 0.266t0.422 0.078 0.422-0.078 0.359-0.266q0.344-0.313 0.344-0.781t-0.344-0.781l-4.063-4.094h8.906q0.625 0 1.063-0.438t0.438-1.063v-23q0-0.625-0.438-1.063t-1.063-0.438v0zM12 6l8 5-8 5v-10zM25 22h-20q-0.406 0-0.703-0.297t-0.297-0.703 0.297-0.703 0.703-0.297h20q0.406 0 0.703 0.297t0.297 0.703-0.297 0.703-0.703 0.297v0z"></path>
    </symbol>

    <!-- PDF -->
    <symbol id="icon-uniEF3E" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-pdf'">
      <title>{{ $t('appUser.resourcesIcons.PDF.name') }}</title>
      <path d="M26.313 18.406q-0.313-0.313-1.016-0.469t-1.797-0.188q-0.719 0-1.594 0.063t-1.781 0.188q-0.406-0.219-0.828-0.484t-0.734-0.578q-0.906-0.844-1.641-1.984t-1.203-2.422q0.031-0.125 0.063-0.234t0.063-0.203l0.313-2.094t0.156-3.063q0-0.125-0.016-0.188l-0.047-0.188-0.063-0.156q-0.156-0.313-0.422-0.578t-0.703-0.266h-0.344q-0.469 0-0.813 0.219t-0.469 0.594q-0.313 1.125-0.047 2.813t0.828 3.875l-0.188 0.5q-0.406 1-0.891 1.984t-0.953 1.891l-0.094 0.156q-0.469 0.938-0.906 1.734t-0.813 1.484l-0.563 0.281q-0.031 0-0.531 0.266t-0.656 0.359q-1.375 0.844-2.25 1.734t-1.031 1.641q-0.031 0.25 0.016 0.516t0.297 0.391l0.531 0.281q0.156 0.063 0.344 0.109t0.375 0.047q0.969 0 2.172-1.281t2.766-4.031q1.844-0.594 3.844-1.078t3.813-0.734q1.375 0.781 2.938 1.266t2.625 0.484q0.188 0 0.359-0.016t0.297-0.047q0.219-0.063 0.375-0.172t0.281-0.266q0.188-0.313 0.25-0.734t0-0.859q0-0.125-0.094-0.281t-0.219-0.281v0zM6.625 25.438q0.156-0.5 0.844-1.375t1.75-1.75q0.063-0.031 0.203-0.172t0.297-0.266q-1.094 1.75-1.859 2.547t-1.234 1.016v0zM14.938 6.25q0.344 0 0.516 0.656t0.172 1.406q0.031 0.75-0.125 1.297t-0.375 0.922q-0.188-0.563-0.266-1.375t-0.078-1.406l0.016-0.75t0.141-0.75v0 0zM12.469 19.906q0.219-0.375 0.453-0.797t0.453-0.859q0.594-1.094 0.969-1.953t0.656-1.578q0.531 1 1.188 1.828t1.469 1.484q0.094 0.094 0.188 0.172t0.219 0.172q-1.594 0.313-2.984 0.703t-2.609 0.828v0 0zM25.906 19.813q-0.094 0.063-0.328 0.094t-0.422 0.031q-0.563 0-1.313-0.25t-1.75-0.688q0.375-0.031 0.734-0.047t0.672-0.016q0.594 0 0.891 0.031t0.891 0.156q0.563 0.156 0.641 0.391t-0.016 0.297v0 0zM28.688 7.156q-0.531-0.719-1.234-1.516t-1.484-1.609q-0.813-0.781-1.609-1.484t-1.516-1.234q-1.219-0.875-1.859-1.094t-0.984-0.219h-15.5q-1.031 0-1.766 0.734t-0.734 1.766v27q0 1.031 0.734 1.766t1.766 0.734h23q1.031 0 1.766-0.734t0.734-1.766v-19.5q0-0.344-0.219-0.984t-1.094-1.859v0 0zM24.531 5.469q0.719 0.719 1.297 1.359t0.984 1.172h-4.813v-4.813q0.531 0.406 1.172 0.984t1.359 1.297v0 0zM28 29.5q0 0.219-0.141 0.359t-0.359 0.141h-23q-0.219 0-0.359-0.141t-0.141-0.359v-27q0-0.219 0.141-0.359t0.359-0.141h15.5v7q0 0.406 0.297 0.703t0.703 0.297h7v19.5z"></path>
    </symbol>

    <!-- Presentation -->
    <symbol id="icon-uniF15D" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-presentation'">
      <title>{{ $t('appUser.resourcesIcons.presentation.name') }}</title>
      <path d="M16.992 32h-1.995v-12h1.995v12zM7.155 31.865l-1.418-1.418 10.394-10.394 1.418 1.418zM26.282 30.44l-1.418 1.418-10.394-10.394 1.418-1.418zM0 2.005h32v20h-32v-20zM28 18.005v-12h-24v12h24zM14.997 2.005v-2.005h1.995v2.005h-1.995z"></path>
    </symbol>

    <!-- Quiz -->
    <symbol id="icon-uniF15E1" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-quiz'">
      <title>{{ $t('appUser.resourcesIcons.quiz.name') }}</title>
      <path d="M1.995 4.011v-2.005h2.005v2.005h-2.005zM7.051 31.957v-2.005h2.005v2.005h-2.005zM5.003 27.968v-2.005h6.005v2.005h-6.005zM5.995 29.941v-2.005h4v2.005h-4zM0 14.005v-12h1.995v12h-1.995zM4 25.995v-25.995h8v25.995h-8zM27.413 12.384l1.547 1.483-4.619 4.267-1.536 1.451-1.536-1.451-2.315-2.133 1.536-1.451 2.304 2.133zM15.957 24v-16h2.005v16h-2.005zM31.957 10.005h-16v-2.005h16v2.005zM31.957 8v16h-2.005v-16h2.005zM15.957 21.995h16v2.005h-16v-2.005z"></path>
    </symbol>

    <!-- Survey -->
    <symbol id="icon-uniF15E2" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-survey'">
      <title>{{ $t('appUser.resourcesIcons.survey.name') }}</title>
      <path d="M1.995 4.011v-2.005h2.005v2.005h-2.005zM7.051 31.957v-2.005h2.005v2.005h-2.005zM5.003 27.968v-2.005h6.005v2.005h-6.005zM5.995 29.941v-2.005h4v2.005h-4zM0 14.005v-12h1.995v12h-1.995zM4 25.995v-25.995h8v25.995h-8zM27.413 12.384l1.547 1.483-4.619 4.267-1.536 1.451-1.536-1.451-2.315-2.133 1.536-1.451 2.304 2.133zM15.957 24v-16h2.005v16h-2.005zM31.957 10.005h-16v-2.005h16v2.005zM31.957 8v16h-2.005v-16h2.005zM15.957 21.995h16v2.005h-16v-2.005z"></path>
    </symbol>

    <!-- Text -->
    <symbol id="icon-uniE99B" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-instructions'">
      <title>{{ $t('appUser.resourcesIcons.text.name') }}</title>
      <path d="M27 0h-24q-1.25 0-2.125 0.875t-0.875 2.125v26q0 1.25 0.875 2.125t2.125 0.875h24q1.25 0 2.125-0.875t0.875-2.125v-26q0-1.25-0.875-2.125t-2.125-0.875v0zM26 28h-22v-24h22v24zM8 14h14v2h-14v-2zM8 18h14v2h-14v-2zM8 22h14v2h-14v-2zM8 10h14v2h-14v-2z"></path>
    </symbol>

    <!-- Video -->
    <symbol id="icon-uniE957" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-video'">
      <title>{{ $t('appUser.resourcesIcons.video.name') }}</title>
      <path
        d="M30.656 5q-1.688-0.25-3.453-0.438t-3.609-0.313-3.734-0.188-3.859-0.063-3.859 0.063-3.734 0.188-3.609 0.313-3.453 0.438q-0.344 1.281-0.578 2.594t-0.406 2.703-0.266 2.813-0.094 2.891 0.094 2.891 0.266 2.813 0.406 2.703 0.578 2.594q1.688 0.25 3.453 0.438t3.609 0.313 3.734 0.188 3.859 0.063 3.859-0.063 3.734-0.188 3.609-0.313 3.453-0.438q0.344-1.281 0.578-2.594t0.406-2.703 0.266-2.813 0.094-2.891-0.094-2.891-0.266-2.813-0.406-2.703-0.578-2.594v0zM12 22v-12l10 6-10 6z"></path>
    </symbol>

    <!-- Web page -->
    <symbol id="icon-uniEC96" viewBox="0 0 32 32" v-if="iconClassLocal === 'jcmsplugin-jlearn-webpage'">
      <title>{{ $t('appUser.resourcesIcons.webPage.name') }}</title>
      <path
        d="M16 0q-3.313 0-6.234 1.25t-5.094 3.422-3.422 5.094-1.25 6.234 1.25 6.234 3.422 5.094 5.094 3.422 6.234 1.25 6.234-1.25 5.094-3.422 3.422-5.094 1.25-6.234-1.25-6.234-3.422-5.094-5.094-3.422-6.234-1.25v0zM16 30q-1.469 0-2.859-0.297t-2.672-0.828l7.281-8.219q0.125-0.125 0.188-0.297t0.063-0.359v-3q0-0.406-0.297-0.703t-0.703-0.297q-1.313 0-2.625-0.578t-2.344-1.266-1.672-1.266-0.641-0.609q-0.156-0.125-0.344-0.203t-0.375-0.078h-4q-0.406 0-0.703 0.297t-0.297 0.703v6q0 0.281 0.156 0.531t0.406 0.375l3.438 1.719v5.875q-1.375-0.969-2.469-2.203t-1.891-2.719-1.219-3.141-0.422-3.438q0-1.625 0.344-3.125t1-2.875h3.656q0.188 0 0.375-0.078t0.344-0.203l4-4q0.125-0.156 0.203-0.344t0.078-0.375v-2.406q0.938-0.281 1.953-0.438t2.047-0.156q1.656 0 3.203 0.359t2.922 1.047q-0.094 0.094-0.188 0.172t-0.188 0.172q-0.844 0.844-1.297 1.953t-0.453 2.297 0.453 2.297 1.297 1.953q0.875 0.844 1.969 1.297t2.281 0.453h0.281q0.188 0.594 0.359 1.672t0.234 2.563-0.109 3.344-0.734 4.047q0 0.031-0.016 0.078t-0.016 0.078q-0.938 1-2.078 1.766t-2.406 1.313-2.656 0.844-2.859 0.297v0z"></path>
    </symbol>
  </section>
</template>

<script>
export default {
  name: 'IconMoon',
  props: {
    iconClass: {
      type: String
    }
  },
  data () {
    return {
      connection: [
        {
          name: 'audio', // TODO: mettre le nom avec i18n
          className: 'jcmsplugin-jlearn-audio',
          iconName: 'icon-uniE948'
        },
        {
          name: 'course',
          className: 'jcmsplugin-jlearn-course',
          iconName: 'icon-uniE95C1'
        },
        {
          name: 'document',
          className: 'jcmsplugin-jlearn-document',
          iconName: 'icon-uniE9AD'
        },
        {
          name: 'guide',
          className: 'jcmsplugin-jlearn-jguide',
          iconName: 'icon-uniEC58'
        },
        {
          name: 'interactive',
          className: 'jcmsplugin-jlearn-interactive',
          iconName: 'icon-uniE99A'
        },
        {
          name: 'onlineCourse',
          className: 'jcmsplugin-jlearn-online-course',
          iconName: 'icon-uniE95C2'
        },
        {
          name: 'PDF',
          className: 'jcmsplugin-jlearn-pdf',
          iconName: 'icon-uniEF3E'
        },
        {
          name: 'presentation',
          className: 'jcmsplugin-jlearn-presentation',
          iconName: 'icon-uniF15D'
        },
        {
          name: 'quiz',
          className: 'jcmsplugin-jlearn-quiz',
          iconName: 'icon-uniF15E1'
        },
        {
          name: 'survey',
          className: 'jcmsplugin-jlearn-survey',
          iconName: 'icon-uniF15E2'
        },
        {
          name: 'text',
          className: 'jcmsplugin-jlearn-instructions',
          iconName: 'icon-uniE99B'
        },
        {
          name: 'video',
          className: 'jcmsplugin-jlearn-video',
          iconName: 'icon-uniE957'
        },
        {
          name: 'webPage',
          className: 'jcmsplugin-jlearn-webpage',
          iconName: 'icon-uniEC96'
        }
      ]
    }
  },
  computed: {
    iconClassLocal () {
      return this.iconClass ? this.iconClass : 'jcmsplugin-jlearn-document'
    },
    iconName () {
      return this.connection.find(connect => connect.className === this.iconClassLocal).iconName
    }
  }
}
</script>

<style lang="scss" scoped>
  #icon__section {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg.icon {
      width: 16px;
      height: 16px;
      fill: white;
    }
  }
</style>
